import React from 'react';
import MuiTextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import EffectiveUserSettings from 'relevant-shared/misc/effectiveUserSettings';
import AutocompleteInput from '../AutocompleteInput';
import TzList from './tzList';

const TimezoneOptions = TzList.map((value) => ({ value }));

function TimezoneSelect(props) {
	const { onChange, value, width, placeholder, name } = props;
	return (
		<AutocompleteInput
			suggestions={TimezoneOptions}
			onChange={(ev) => {
				onChange({
					target: {
						name,
						...ev,
						...(!('value' in (ev || {})) && { value: null }),
					},
				});
			}}
			value={value}
			autocompleteProps={{
				renderInput: (params) => (
					<MuiTextField
						{...params}
						label="Timezone"
						placeholder={placeholder === undefined ? EffectiveUserSettings.current().timezone : placeholder}
						InputLabelProps={{ shrink: true }}
					/>
				),
				isOptionEqualToValue: (option, val) => (option.value === (val.value || val)),
				getOptionLabel: (option) => option.value || option,
				sx: { width },
				componentsProps: {
					paper: {
						sx: {
							width,
						},
					},
				},
			}}
		/>
	);
}

TimezoneSelect.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	value: PropTypes.any,
	width: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	name: PropTypes.string,
};

TimezoneSelect.defaultProps = {
	value: null,
	width: null,
	placeholder: undefined,
	name: undefined,
};

export default TimezoneSelect;
